const MANIFEST_ICONS = {
  account: {
    hashed: 'account.d3606fc8eaa69072e51443f2a0a6f522.svg',
    versioned: 'account.svg'
  },
  add: {
    hashed: 'add.335f200c10fc31f206512c22970b0010.svg',
    versioned: 'add.svg'
  },
  alignCenter: {
    hashed: 'align_center.6d006571282d183720cb2ba32d83f7e2.svg',
    versioned: 'align_center.svg'
  },
  alignLeft: {
    hashed: 'align_left.b69a3d72ff112b3256515ed57c2f531b.svg',
    versioned: 'align_left.svg'
  },
  alignRight: {
    hashed: 'align_right.dc7a099276d89b4225fd9da3b0a0f63e.svg',
    versioned: 'align_right.svg'
  },
  arrowLeft: {
    hashed: 'arrow_left.f436ae8ebc30a9435c1d59642bf78e8b.svg',
    versioned: 'arrow_left.svg'
  },
  arrowRight: {
    hashed: 'arrow_right.b75db7a964c0e26c4d1da0075e0a7ad6.svg',
    versioned: 'arrow_right.svg'
  },
  bringToFront: {
    hashed: 'bring_to_front.fac094eb4754a4899b76499e2bf1f289.svg',
    versioned: 'bring_to_front.svg'
  },
  browseDesigns: {
    hashed: 'browse_designs.e42cb33e9ce4c9091305f75d78b7d250.svg',
    versioned: 'browse_designs.svg'
  },
  calendar: {
    hashed: 'calendar.acd6a09156e0c93b64ca7aea180bfa76.svg',
    versioned: 'calendar.svg'
  },
  caretDown: {
    hashed: 'caret_down.94a97f39eecd024c3c298258a724fbb3.svg',
    versioned: 'caret_down.svg'
  },
  caretUp: {
    hashed: 'caret_up.5dc4b5b643f8ac15f29f39a153781c7a.svg',
    versioned: 'caret_up.svg'
  },
  chatReview: {
    hashed: 'chat_review.64f3685ed863e19cf2ba32615b1fc10e.svg',
    versioned: 'chat_review.svg'
  },
  check: {
    hashed: 'check.433ef8b9d9cf3d5e5f668f4178e2e4ad.svg',
    versioned: 'check.svg'
  },
  chevronLeft: {
    hashed: 'chevron_left.d88a892c3520b91832a66d3eccedc248.svg',
    versioned: 'chevron_left.svg'
  },
  chevronRight: {
    hashed: 'chevron_right.c8a87ecb8998c2c9cb7768c9f85d6902.svg',
    versioned: 'chevron_right.svg'
  },
  clock: {
    hashed: 'clock.f7549744e789406fe9614a6418738567.svg',
    versioned: 'clock.svg'
  },
  closeLarge: {
    hashed: 'close_large.2e9b871d4928f31555c26d44b91fd3fe.svg',
    versioned: 'close_large.svg'
  },
  closeSmall: {
    hashed: 'close_small.c61934330d7377369d3cd39602271dbe.svg',
    versioned: 'close_small.svg'
  },
  close: {
    hashed: 'close.85e7f885b43a4696861ed533934f3b01.svg',
    versioned: 'close.svg'
  },
  deleteStudio: {
    hashed: 'delete_studio.4d851967005e4e6ebcb0ed1ae3fa509c.svg',
    versioned: 'delete_studio.svg'
  },
  delete: {
    hashed: 'delete.63c4705bc5138640f33ffe5f2d1c8871.svg',
    versioned: 'delete.svg'
  },
  designEducation: {
    hashed: 'design_education.24a33456d76b080e1e98499709e89c5b.svg',
    versioned: 'design_education.svg'
  },
  designerMarketplace: {
    hashed: 'designer_marketplace.53a32433dc80e7e6fb3efb20fdff78f4.svg',
    versioned: 'designer_marketplace.svg'
  },
  download: {
    hashed: 'download.5071ebfee14fd2d334fcabff5a04fce9.svg',
    versioned: 'download.svg'
  },
  edit: {
    hashed: 'edit.5f52f78669816be1323e363b0eb9f665.svg',
    versioned: 'edit.svg'
  },
  email: {
    hashed: 'email.a91d787063cd4d323fde83f203161c6f.svg',
    versioned: 'email.svg'
  },
  error: {
    hashed: 'error.1e4fa178818cb8bb96de07fe33334fba.svg',
    versioned: 'error.svg'
  },
  fileAi: {
    hashed: 'file_ai.1f2ac393c9e0815e6d36c55c77032971.svg',
    versioned: 'file_ai.svg'
  },
  fileEps: {
    hashed: 'file_eps.e20d9fe1fe903bff66c61d063ad1af1f.svg',
    versioned: 'file_eps.svg'
  },
  fileGeneric: {
    hashed: 'file_generic.96fdf376a513532079a3fcdb3777104d.svg',
    versioned: 'file_generic.svg'
  },
  fileId: {
    hashed: 'file_id.9b7f9065fc78179aad8c2ca3d91a3903.svg',
    versioned: 'file_id.svg'
  },
  filePdf: {
    hashed: 'file_pdf.600adc4327ac78bfcf0e571419f8902e.svg',
    versioned: 'file_pdf.svg'
  },
  filePsd: {
    hashed: 'file_psd.243c61b305431c59da074ea08e2eeb3e.svg',
    versioned: 'file_psd.svg'
  },
  filter: {
    hashed: 'filter.eda239b3bb5214ec108eb72a04b03f4c.svg',
    versioned: 'filter.svg'
  },
  focus: {
    hashed: 'focus.7730dedb8912b78e9b6be1208b43eda0.svg',
    versioned: 'focus.svg'
  },
  fullCurveDown: {
    hashed: 'full_curve_down.5d76078e4014514221ae3278144c0115.svg',
    versioned: 'full_curve_down.svg'
  },
  fullCurveUp: {
    hashed: 'full_curve_up.550f784f020c4095db8b7c2270f36992.svg',
    versioned: 'full_curve_up.svg'
  },
  fullDesign: {
    hashed: 'full_design.89ca5a4a7ae74d4b127cd42f5be9f736.svg',
    versioned: 'full_design.svg'
  },
  guaranteedSatisfaction: {
    hashed: 'guaranteed_satisfaction.768334e2743de4dfb18dd5efe797ff79.svg',
    versioned: 'guaranteed_satisfaction.svg'
  },
  heart: {
    hashed: 'heart.213594b529cf179f60e5986f5dc0bb86.svg',
    versioned: 'heart.svg'
  },
  helpQuery: {
    hashed: 'help_query.dc41f31bc70228e5ceb71cab865d9269.svg',
    versioned: 'help_query.svg'
  },
  help: {
    hashed: 'help.93f47fc72c104e955b50b6ed0d682dfe.svg',
    versioned: 'help.svg'
  },
  image: {
    hashed: 'image.fdb5f9872304ab86d565b540f13a228f.svg',
    versioned: 'image.svg'
  },
  info: {
    hashed: 'info.fa2701c46623c0f0605d97b74aea980f.svg',
    versioned: 'info.svg'
  },
  list: {
    hashed: 'list.38c480b4f5f9aa79dac9f2b769a1eadd.svg',
    versioned: 'list.svg'
  },
  liveChat: {
    hashed: 'live_chat.eea4c84c32fa15f60234206d7ce34dbc.svg',
    versioned: 'live_chat.svg'
  },
  login: {
    hashed: 'login.efa797976e8970334cb1a31224455234.svg',
    versioned: 'login.svg'
  },
  logo: {
    hashed: 'logo.6581a00307992e9e21a2d662f4892747.svg',
    versioned: 'logo.svg'
  },
  magic: {
    hashed: 'magic.022badf6594e3d6218f1924576a13f02.svg',
    versioned: 'magic.svg'
  },
  menu: {
    hashed: 'menu.1bfe004f554233204f0c93c9ed4221f8.svg',
    versioned: 'menu.svg'
  },
  minus: {
    hashed: 'minus.c812175ed735b1687043da0aaba1b4f7.svg',
    versioned: 'minus.svg'
  },
  myDigitalMarketing: {
    hashed: 'my_digital_marketing.d48c7ef77c46a36c24d7073346855694.svg',
    versioned: 'my_digital_marketing.svg'
  },
  myProjects_1: {
    hashed: 'my_projects_1.dae64281342e6cc249fe2b3591b6565f.svg',
    versioned: 'my_projects_1.svg'
  },
  myProjects: {
    hashed: 'my_projects.315e9290f383b2a657d6e306aaec007d.svg',
    versioned: 'my_projects.svg'
  },
  numericList: {
    hashed: 'numeric_list.18919d48f6079aacb542a81031a2fb61.svg',
    versioned: 'numeric_list.svg'
  },
  orderHistory: {
    hashed: 'order_history.ab5766581cfc82c6062c14ef52a219c7.svg',
    versioned: 'order_history.svg'
  },
  passwordHide: {
    hashed: 'password_hide.50720e5e99134e5360627e30e1db573c.svg',
    versioned: 'password_hide.svg'
  },
  passwordShow: {
    hashed: 'password_show.4a2e68363c02037576aedd075f5e5537.svg',
    versioned: 'password_show.svg'
  },
  pause: {
    hashed: 'pause.b2800295fa1beec792104dd1fb88e664.svg',
    versioned: 'pause.svg'
  },
  phoneCall: {
    hashed: 'phone_call.7d80cd48d6759eb7776a31f4657fe717.svg',
    versioned: 'phone_call.svg'
  },
  phone: {
    hashed: 'phone.92c54dfc6fa35b1e02f10d16b45be2d2.svg',
    versioned: 'phone.svg'
  },
  play: {
    hashed: 'play.e64ab3bfc019de563551632e15bbda8b.svg',
    versioned: 'play.svg'
  },
  plusRounded: {
    hashed: 'plus_rounded.f70135904b490b1f2909467fa038a7d0.svg',
    versioned: 'plus_rounded.svg'
  },
  plus: {
    hashed: 'plus.c3e67346f5b3658e28329f74a8b9293c.svg',
    versioned: 'plus.svg'
  },
  polish: {
    hashed: 'polish.95b15f14919aa2dbd0e02d1391a3f2be.svg',
    versioned: 'polish.svg'
  },
  preview: {
    hashed: 'preview.517c8afc5ab733d278b2edb04051886b.svg',
    versioned: 'preview.svg'
  },
  priceTag: {
    hashed: 'price_tag.27b680081798c7a679fb4a0626e98f5f.svg',
    versioned: 'price_tag.svg'
  },
  printedProducts: {
    hashed: 'printed_products.e9be92d55fac3c380367327e09969c91.svg',
    versioned: 'printed_products.svg'
  },
  qrCode: {
    hashed: 'qr_code.aef6be145666cfad9cb6a292b57d0f56.svg',
    versioned: 'qr_code.svg'
  },
  redoLegacy: {
    hashed: 'redo_legacy.22610beee8db30774ade731e360c6c7b.svg',
    versioned: 'redo_legacy.svg'
  },
  redo: {
    hashed: 'redo.da41b3df65d9bfb1b136b11dbd093125.svg',
    versioned: 'redo.svg'
  },
  reorder: {
    hashed: 'reorder.3c1b8488879ae56b4ef7bde01d446e85.svg',
    versioned: 'reorder.svg'
  },
  reset: {
    hashed: 'reset.ab046072c5aa94694453ced8047eb65a.svg',
    versioned: 'reset.svg'
  },
  rotate: {
    hashed: 'rotate.44da32c7ecb092a307734446b0dd615a.svg',
    versioned: 'rotate.svg'
  },
  roundedCorners: {
    hashed: 'rounded_corners.2e442c1a68f34369ba6092eeb7f39b8b.svg',
    versioned: 'rounded_corners.svg'
  },
  satisfaction: {
    hashed: 'satisfaction.466463eff1d62451410555b4ed474eb3.svg',
    versioned: 'satisfaction.svg'
  },
  saveAsCopy: {
    hashed: 'save_as_copy.e9d491299a6bfe2b9f56c993ca15b3a2.svg',
    versioned: 'save_as_copy.svg'
  },
  save: {
    hashed: 'save.a62c111c475d6c0a69c6b9fd9a5a3013.svg',
    versioned: 'save.svg'
  },
  searchLarge: {
    hashed: 'search-large.6d886bd63418e00c7612be228d20683e.svg',
    versioned: 'search-large.svg'
  },
  search: {
    hashed: 'search.3594f845fd4e26d76fd4cf3b291a9e7e.svg',
    versioned: 'search.svg'
  },
  sendToBack: {
    hashed: 'send_to_back.3e0f9e09bd9c46267fe7877676d6d190.svg',
    versioned: 'send_to_back.svg'
  },
  shapes: {
    hashed: 'shapes.d78cbfcaf5f5631f05ff6997370ad1ed.svg',
    versioned: 'shapes.svg'
  },
  shoppingBag_0: {
    hashed: 'shopping_bag_0.d8cba57b83930342942937c2c5637a91.svg',
    versioned: 'shopping_bag_0.svg'
  },
  shoppingBag_1: {
    hashed: 'shopping_bag_1.7b929ecf3f3e17f7f6d0935d8f73d2de.svg',
    versioned: 'shopping_bag_1.svg'
  },
  shoppingBag_10: {
    hashed: 'shopping_bag_10.69ac81fc4226fe5ea7c83dc6fb5146cf.svg',
    versioned: 'shopping_bag_10.svg'
  },
  shoppingBag_11: {
    hashed: 'shopping_bag_11.40f3a5fb4cf7c90a68c912c39adf7480.svg',
    versioned: 'shopping_bag_11.svg'
  },
  shoppingBag_12: {
    hashed: 'shopping_bag_12.53f093d9918e4a1751eaa9d4020b8641.svg',
    versioned: 'shopping_bag_12.svg'
  },
  shoppingBag_13: {
    hashed: 'shopping_bag_13.434cb87087c241ff2e84a2d6e065b18b.svg',
    versioned: 'shopping_bag_13.svg'
  },
  shoppingBag_14: {
    hashed: 'shopping_bag_14.896575f97aca373f5683798af1537670.svg',
    versioned: 'shopping_bag_14.svg'
  },
  shoppingBag_2: {
    hashed: 'shopping_bag_2.d33f237446c6a34cb94fb576fdf4e1fc.svg',
    versioned: 'shopping_bag_2.svg'
  },
  shoppingBag_3: {
    hashed: 'shopping_bag_3.92fcfbdf10d52364351f296a846fd769.svg',
    versioned: 'shopping_bag_3.svg'
  },
  shoppingBag_4: {
    hashed: 'shopping_bag_4.29e97df748227c812029226f4e4c8909.svg',
    versioned: 'shopping_bag_4.svg'
  },
  shoppingBag_5: {
    hashed: 'shopping_bag_5.e24f699fb2b25253aa1c90215b30a927.svg',
    versioned: 'shopping_bag_5.svg'
  },
  shoppingBag_50: {
    hashed: 'shopping_bag_50.178be4e6ef11894ea3bff8ec74160131.svg',
    versioned: 'shopping_bag_50.svg'
  },
  shoppingBag_6: {
    hashed: 'shopping_bag_6.930de960bfd3ab45490bd5fc040c41d7.svg',
    versioned: 'shopping_bag_6.svg'
  },
  shoppingBag_7: {
    hashed: 'shopping_bag_7.561f46ccf1e7a2950f4654964036edcc.svg',
    versioned: 'shopping_bag_7.svg'
  },
  shoppingBag_8: {
    hashed: 'shopping_bag_8.6b9a0f34101dcb69a513696e3bd9e82b.svg',
    versioned: 'shopping_bag_8.svg'
  },
  shoppingBag_9: {
    hashed: 'shopping_bag_9.f11d0b4060a7b527a85a1bb2a395019d.svg',
    versioned: 'shopping_bag_9.svg'
  },
  slightCurveDown: {
    hashed: 'slight_curve_down.8f25aa8e67425f69e89cdd2cfff9ad9e.svg',
    versioned: 'slight_curve_down.svg'
  },
  slightCurveUp: {
    hashed: 'slight_curve_up.848294eb55b8aaba4ad041c073be2ee1.svg',
    versioned: 'slight_curve_up.svg'
  },
  sparkle: {
    hashed: 'sparkle.22cba0229638d93776f72f81b4b26051.svg',
    versioned: 'sparkle.svg'
  },
  square: {
    hashed: 'square.dd4df6b0408369cbf3ac5f4d58e5f872.svg',
    versioned: 'square.svg'
  },
  standard: {
    hashed: 'standard.28a747165d4365298accdee60b4af0da.svg',
    versioned: 'standard.svg'
  },
  straight: {
    hashed: 'straight.14276a93ba876c7333d738d33f3d182a.svg',
    versioned: 'straight.svg'
  },
  tables: {
    hashed: 'tables.b35e668feb1ccb700c6e76e7dad9a0e4.svg',
    versioned: 'tables.svg'
  },
  templates: {
    hashed: 'templates.6bba82ee7cf98e41f9b097d5f7512a47.svg',
    versioned: 'templates.svg'
  },
  text: {
    hashed: 'text.d71177e206ffe43c9c0257cdea1e9937.svg',
    versioned: 'text.svg'
  },
  twoSide: {
    hashed: 'two_side.a074849d56d65bd0416dd885787e8f38.svg',
    versioned: 'two_side.svg'
  },
  undoLegacy: {
    hashed: 'undo_legacy.17e232db7263e2bcbbf094d621c8a3df.svg',
    versioned: 'undo_legacy.svg'
  },
  undo: {
    hashed: 'undo.3d9dda20eed03bcd97a8872637d38272.svg',
    versioned: 'undo.svg'
  },
  uploadYourArtwork: {
    hashed: 'upload_your_artwork.308b8436a7a5ec463da631c5d97ff63b.svg',
    versioned: 'upload_your_artwork.svg'
  },
  upload: {
    hashed: 'upload.faf3d257e58b9c5ff9b97b20b1b52f2a.svg',
    versioned: 'upload.svg'
  },
  vertical: {
    hashed: 'vertical.90218ec7689713dbd7c1ced8ebb3b77a.svg',
    versioned: 'vertical.svg'
  },
  view: {
    hashed: 'view.d19eb208f48b995639d8137ea1284be4.svg',
    versioned: 'view.svg'
  },
  wayfinding: {
    hashed: 'wayfinding.f02d0ff8fb660b1e5330c49a3752344e.svg',
    versioned: 'wayfinding.svg'
  },
  workWithAPro: {
    hashed: 'work_with_a_pro.992396b3f7bdddacb72cfe69055974de.svg',
    versioned: 'work_with_a_pro.svg'
  },
  zoomIn: {
    hashed: 'zoom_in.714c54c4dc4f195abc1746b320009833.svg',
    versioned: 'zoom_in.svg'
  },
  zoomOut: {
    hashed: 'zoom_out.1ac262885335416d52761869c2208754.svg',
    versioned: 'zoom_out.svg'
  }
};
export { MANIFEST_ICONS };